import ArrowLeftOutlined from '@ant-design/icons/ArrowLeftOutlined';
import FormOutlined from '@ant-design/icons/FormOutlined';
import MailOutlined from '@ant-design/icons/MailOutlined';
import BellOutlined from '@ant-design/icons/BellOutlined';

const notificacoes = {
  id: 'group-notificacoes',
  title: 'Notificações',
  type: 'group',
  children: [
    {
      id: 'back-to-core',
      title: 'Voltar ao Principal',
      type: 'item',
      url: '/dashboard',
      icon: ArrowLeftOutlined,
      breadcrumbs: false
    },
    {
      id: 'notificacoes-envios',
      title: 'Envios',
      type: 'item',
      url: '/notificacoes/envios',
      icon: MailOutlined,
      permissions: ['notificacoes.envios.view'],
      breadcrumbs: false
    },
    {
      id: 'notificacoes-templates',
      title: 'Templates',
      type: 'item',
      url: '/notificacoes/templates',
      icon: FormOutlined,
      permissions: ['notificacoes.templates.view'],
      breadcrumbs: false
    },
    {
      id: 'notificacoes-alertas',
      title: 'Central de Alertas',
      type: 'item',
      url: '/notificacoes/alertas',
      icon: BellOutlined,
      permissions: ['notificacoes.templates.view'],
      breadcrumbs: false
    }
  ]
};

export default notificacoes;
